// src/pages/FeedbackPage.js
import React, { useState } from "react";
import api from "../api/axiosConfig";

const FEEDBACK_BOARD_ID = 2; // <- deine Board-ID

const TYPE_OPTIONS = [
  { value: "Bug", label: "Bug" },
  { value: "Feature", label: "Feature" },
  { value: "Idea", label: "Idee" },
  { value: "Other", label: "Sonstiges" },
];

export default function FeedbackPage() {
  const [type, setType] = useState("Bug");
  const [title, setTitle] = useState("");
  const [details, setDetails] = useState("");
  const [ok, setOk] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setOk(""); setErr("");
    if (!title.trim()) { setErr("Bitte Titel angeben"); return; }
    setLoading(true);
    try {
      // Label nach Typ setzen (z. B. "Bug", "Feature", ...)
      const labels = [type];             // <- HIER landet der Typ als Label
      const priority = 0;                // optional: z. B. 0=Low

      await api.post(`/boards/${FEEDBACK_BOARD_ID}/tasks`, {
        title: title.trim(),
        status: "offen",
        details: details || "",
        labels,
        priority,
      });

      setOk("Danke! Feedback ist angekommen. 🎉");
      setTitle(""); setDetails("");
      setType("Bug");
    } catch (e2) {
      setErr(e2?.response?.data?.error || "Senden fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-container">
      <div className="info-card">
        <h2>Feedback</h2>
        <form onSubmit={submit} className="feedback-form">
          <label>Typ</label>
          <select value={type} onChange={(e)=>setType(e.target.value)}>
            {TYPE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>

          <label>Titel*</label>
          <input value={title} onChange={(e)=>setTitle(e.target.value)} required />

          <label>Details</label>
          <textarea rows={4} value={details} onChange={(e)=>setDetails(e.target.value)} />

          <button className="btn" type="submit" disabled={loading}>
            {loading ? "Sende…" : "Abschicken"}
          </button>

          {ok && <p className="form-success">{ok}</p>}
          {err && <p className="form-error">{err}</p>}
        </form>
      </div>
    </div>
  );
}
